import { useState, useCallback } from 'react';
import type { FilterState } from '../../types/orders';

interface FilterBarProps {
  filters: FilterState;
  onFilter: (filters: FilterState) => void;
  onClear: () => void;
}

export function FilterBar({ filters, onFilter, onClear }: FilterBarProps) {
  const [dateFrom, setDateFrom] = useState(toInputDate(filters.date_from));
  const [dateTo, setDateTo] = useState(toInputDate(filters.date_to));

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    onFilter({
      date_from: toDisplayDate(dateFrom),
      date_to: toDisplayDate(dateTo),
    });
  }, [dateFrom, dateTo, onFilter]);

  const handleClear = useCallback(() => {
    setDateFrom('');
    setDateTo('');
    onClear();
  }, [onClear]);

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4 md:flex-row md:items-end">
        <div className="flex flex-1 flex-col gap-3 sm:flex-row">
          <div className="flex flex-1 flex-col gap-1 sm:max-w-[200px]">
            <label htmlFor="date_from" className="text-[13px] font-medium text-gray-500">Desde</label>
            <input
              id="date_from"
              type="date"
              className="h-10 rounded-lg border border-gray-300 px-3 text-sm text-gray-800 outline-none transition-colors focus:border-green-500 focus:ring-2 focus:ring-green-200"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </div>
          <div className="flex flex-1 flex-col gap-1 sm:max-w-[200px]">
            <label htmlFor="date_to" className="text-[13px] font-medium text-gray-500">Hasta</label>
            <input
              id="date_to"
              type="date"
              className="h-10 rounded-lg border border-gray-300 px-3 text-sm text-gray-800 outline-none transition-colors focus:border-green-500 focus:ring-2 focus:ring-green-200"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </div>
        </div>
        <div className="flex gap-3">
          <button
            type="submit"
            className="h-10 rounded-lg bg-green-600 px-5 text-sm font-semibold text-white transition-colors hover:bg-green-700"
          >
            Filtrar
          </button>
          <button
            type="button"
            className="h-10 rounded-lg border border-gray-300 bg-gray-50 px-5 text-sm font-semibold text-gray-600 transition-colors hover:bg-gray-100"
            onClick={handleClear}
          >
            Limpiar
          </button>
        </div>
      </form>
    </div>
  );
}

/** dd/mm/yyyy → yyyy-mm-dd */
function toInputDate(s: string): string {
  if (!s) return '';
  const p = s.split('/');
  if (p.length !== 3) return '';
  return `${p[2]}-${p[1].padStart(2, '0')}-${p[0].padStart(2, '0')}`;
}

/** yyyy-mm-dd → dd/mm/yyyy */
function toDisplayDate(s: string): string {
  if (!s) return '';
  const p = s.split('-');
  if (p.length !== 3) return '';
  return `${p[2]}/${p[1]}/${p[0]}`;
}
